import React from 'react';
import cn from 'classname';

import withIntl from '../../../shared/intl-hoc';

import MoneyAmountWithCurrency from '../../../shared/money/money-amount-with-currency';

function formatPayoutDate(date) {
	return date && date.format('HH:mm DD.MM.YYYY');
}

function PayoutRow({ intl, payout, ...props }) {
	return (
		<tr {...props}>
			<td className="history-datetime">
				{formatPayoutDate(payout.created_at)}
			</td>
			<td>
				{payout.id}
			</td>
			<td className="payout-amount">
				<MoneyAmountWithCurrency
					className={`amount-${payout.status.value}`}
					amount={payout.amount}
					keepDecimals
					currency={payout.currency}
				/>
				{!!payout.commission && (
					<div className="commission">
						<span>{intl(payout.commission > 0 ? 'бонус' : 'комиссия')}</span>
						<MoneyAmountWithCurrency
							className="commission-amount"
							amount={payout.commission * (payout.commission > 0 ? 1 : -1)}
							keepDecimals
							currency={payout.currency}
						/>
					</div>
				)}
			</td>
			<td className="payout-system">
				{payout.system && payout.system.name}
			</td>
			<td className={cn({ 'payout-rejected_at': payout.rejected_at })}>
				{formatPayoutDate(payout.paid_at || payout.rejected_at)}
			</td>
			<td className="payout-status">
				<span className={`status-${payout.status.value}`}>
					{payout.status.label}
				</span>
			</td>
		</tr>
	);
}

export default withIntl(PayoutRow);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/payout-table/payout-row.js